import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { FirebaseTimestampType } from 'firebase/index'
import { Spacer } from 'components/Utility'
import { addSeconds, format, differenceInSeconds } from 'date-fns'
import { StoreType } from 'types/store'

type Props = {
  createdDate: Date
  description: string
  discountAmount: number
  discountRate: number
  expiresAt: FirebaseTimestampType | undefined
  expiresMaxage: number
  isFirst: boolean
  maxDiscount: number
  maxPerUser: number
  minAmount: number
  name: string
  storeIds: string[]
  stores: StoreType[]
}

const CouponCard: FC<Props> = (props) => {
  const {
    createdDate,
    description,
    discountAmount,
    discountRate,
    expiresAt,
    expiresMaxage,
    name,
    maxDiscount,
    maxPerUser,
    minAmount,
    isFirst,
    storeIds,
    stores,
  } = props
  const discount = discountAmount > 0 ? `${discountAmount.toLocaleString()}円` : `${discountRate}%`

  const expiration = (): string => {
    // 固定期限が設定されていない
    if ((!expiresAt || !expiresAt.seconds) && expiresMaxage === 0) return '期限無し'
    const expiresMaxageDate = addSeconds(createdDate, expiresMaxage)
    if (!expiresAt || !expiresAt.seconds) {
      return format(expiresMaxageDate, 'yyyy年MM月dd日')
    } else if (expiresMaxage === 0) {
      // 相対期限が設定されていない場合は固定期限を返す
      return format(expiresAt.toDate(), 'yyyy年MM月dd日')
    } else {
      const diff = differenceInSeconds(expiresAt.toDate(), new Date())
      const expiredDate = diff > expiresMaxage ? expiresAt.toDate() : expiresMaxageDate
      return format(expiredDate, 'yyyy年MM月dd日')
    }
  }

  const conditionOfUse = (): string => {
    const firstCondition = isFirst ? '初回購入限定' : ''
    const storeNames = storeIds
      .map((storeId) => {
        const store = stores.find((store) => store.store_id && store.store_id === storeId)
        if (!store) return ''
        return store.name
      })
      .join('、')
    const storeCondition = storeNames.length > 0 ? `、${storeNames}限定` : ''
    return firstCondition + storeCondition
  }

  const countOfUse = maxPerUser === 0 ? '回数制限なし' : `クーポンの利用回数は${maxPerUser}回まで`

  return (
    <div className={styles.coupon}>
      <h2 className={styles.coupon__title}>{name}</h2>
      <div className={styles.coupon__border} />
      <div className={styles.coupon__content}>
        <p>
          {discount}割引
          {minAmount > 0 && `/ ${minAmount.toLocaleString()}円（税込）以上の購入のみ`}
          {maxDiscount > 0 && `/ 最大割引額${maxDiscount.toLocaleString()}円`}
        </p>
        <p>有効期限 : {expiration()}</p>
        <p>利用条件 : {conditionOfUse()}</p>
        <p>利用回数 : {countOfUse}</p>
        <Spacer size={16} />
        <p>{description}</p>
      </div>
      <img className={styles.coupon_bg} src={'/bg/sacri_mask.svg'} alt={''} />
    </div>
  )
}

export default CouponCard
